import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const regex = new RegExp(`file/d/(.*?)/view`);
    const match = regex.exec(row['Google file ID']);
    const imageUrl = match?.[1] ? 'https://drive.google.com/uc?id=' + match[1].trim() : null;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['Company ID'],
            header: {
                title: row['Company name'],
                text: row['Company description'],
                imageUrl
            }
        },
        cards: []
    };

    const hasAddressCard = row['Address'];
    const addressCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Adresse',
            description: row['Address']?.trim()
        }
    };

    const hasWebsite = row['Website']?.trim();
    const websiteCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];
            if (row['Website']) {
                links.push({
                    title: 'Website',
                    url: row['Website']?.trim()
                });
            }
            return links;
        })()
    };

    const hasProfilCard = row['Profil(s) recherché(s)']?.trim();
    const profilCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Profil(s) recherché(s)',
            description: row?.['Profil(s) recherché(s)']?.trim()
        }
    };

    const hasPosteCard = row['Poste(s) à pourvoir']?.trim();
    const posteCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Poste(s) à pourvoir',
            description: row?.['Poste(s) à pourvoir']?.trim()
        }
    };

    const hasFinaliteCard = row['Finalité(s) recherchée(s)']?.trim();
    const finaliteCard: CardInputWithType = {
        type: ECardType.TEXT,
        info: {
            title: 'Finalité(s) recherchée(s)',
            description: row?.['Finalité(s) recherchée(s)']?.trim()
        }
    };

    if (hasAddressCard) {
        mutationPayload.cards.push(addressCard);
    }
    if (hasWebsite) {
        mutationPayload.cards.push(websiteCard);
    }
    if (hasProfilCard) {
        mutationPayload.cards.push(profilCard);
    }
    if (hasPosteCard) {
        mutationPayload.cards.push(posteCard);
    }
    if (hasFinaliteCard) {
        mutationPayload.cards.push(finaliteCard);
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row['Company ID']?.toLowerCase();
}

export const liegeImportMethods = { duplicateChecker, parser };
